import React, { createContext, useContext, ReactNode } from "react";
import {
  useDashboardManager,
  DashboardMeta,
} from "../hooks/useDashboardManager";

export type { DashboardMeta };

interface DashboardManagerContextType {
  dashboards: DashboardMeta[];
  activeDashboard: DashboardMeta | null;
  activeDashboardId: string | null;
  isLoading: boolean;
  isCreating: boolean;
  isDeleting: boolean;
  isRenaming: boolean;
  isPublishing: boolean;
  error: string | null;
  createDashboard: (name?: string) => Promise<DashboardMeta>;
  selectDashboard: (dashboardId: string) => void;
  renameDashboard: (dashboardId: string, newName: string) => Promise<void>;
  deleteDashboard: (dashboardId: string) => Promise<void>;
  publishDashboard: (dashboardId: string, publish: boolean) => Promise<void>;
  setDefaultDashboard: (dashboardId: string) => Promise<void>;
}

const DashboardManagerContext = createContext<
  DashboardManagerContextType | undefined
>(undefined);

interface DashboardManagerProviderProps {
  children: ReactNode;
}

export function DashboardManagerProvider({
  children,
}: DashboardManagerProviderProps) {
  const manager = useDashboardManager();

  return (
    <DashboardManagerContext.Provider value={manager}>
      {children}
    </DashboardManagerContext.Provider>
  );
}

export function useDashboardManagerContext() {
  const context = useContext(DashboardManagerContext);
  if (context === undefined) {
    throw new Error(
      "useDashboardManagerContext must be used within a DashboardManagerProvider",
    );
  }
  return context;
}
